import React, { useState, useEffect , useCallback, Fragment} from 'react';
import { Layout, Row, Col, Avatar, Menu, Dropdown, Icon, Tooltip, Badge } from 'antd';
import { NavLink } from 'react-router-dom';
import SideMenu from './components/SideMenu';
// import logo from '../assets/images/logo_sd.png';
import logo_icon from '../assets/images/logo_icon.svg';
import sidebar_collapse from '../assets/images/sidebar_collpase.svg';
import sidebar_expand from '../assets/images/sidebar_expand.svg';
import SettingIcon from './components/common/SettingIcon';
import EditIcon from './components/common/EditIcon';
import { withRouter } from 'react-router-dom';
import MenuOptions from './components/dashboard/MenuOptions';
import { checkServiceExistance, clearSession } from './helpers/common';
import { TableImageColumn } from './common/TableImageColumn';
import SiderFooter from './SiderFooter';
import { FeIcon } from './common/CustomIcon';
import platdform_logo from "../assets/images/platform_logo.svg";
// import sidebar_expand from "../assets/images/CollapseMenuIcon.svg";
import { marginTop10 } from './helpers/invoice_styles';

const { Sider } = Layout;


function MemoizedSider(props) {
  const [collapsed, setCollapsed] = useState(true);
  const { changeMenuStatus, menuStatus, isClosedPinned, currentUser, history, landingPage, renderBanner, userContext } = props;
  const [ isPinned, setIsPinned ] = useState(menuStatus === "pinned");
  const [isPinnedClosed, setIsPinnedClosed] = useState(isClosedPinned === "pinned");
  const orgLogo =currentUser?.currentOrg?.logo?.url;
  const isCollapsed = menuStatus == "pinned" ? false : isClosedPinned == 'pinned' ? true : collapsed ? true : false

  const handleToggle = () => {
    if (isPinned) {
      handlePinning(false);
    } else {
      handlePinning(true);
    }
  };

  const handlePinning = useCallback((checked) => {
    if (checked) {
      localStorage.setItem("menuStatus", "pinned");
      changeMenuStatus('isOpenPinned', "pinned");
      setIsPinned(true);
    } else {
      localStorage.setItem("menuStatus", "un-pinned");
      changeMenuStatus('isOpenPinned', "un-pinned");
      setIsPinned(false);
    }
  }
    , [menuStatus]);


  const handleClosedPinning = useCallback((checked) => {
    if (checked) {
      localStorage.setItem("isClosedPinned", "pinned");
      changeMenuStatus('isClosePinned', "pinned");
      setIsPinnedClosed(true);
    } else {
      localStorage.setItem("isClosedPinned", "un-pinned");
      changeMenuStatus('isClosePinned', "un-pinned");
      setIsPinnedClosed(false);
    }
  }, [isClosedPinned]);

  const renderLogo = (isCollapsed) => {
    const logo = isCollapsed ? (
      <FeIcon styling={{ width: 32, height: 32, marginLeft: '8px' }} />
    ) : (
      <img src={platdform_logo} style={{ width: '100%', height: '40px' }} />
    );

    if (userContext?.currentOrg?.fleet_lite === "true") {
      return (
        <Badge
          count={"Lite"}
          style={{ backgroundColor: '#576EC1', color: '#fff', fontWeight: 'bold' }}
        >
          {logo}
        </Badge>
      );
    }
    return logo;
  };



  return (
    <Sider
      style={{
        //marginTop: 50,
        position: "fixed",
        height: "100vh",
        zIndex: 98,
        borderRight: `${!collapsed ? "2px solid rgb(241, 242, 245)" : "none"}`,
        width: '88px !important',
        minWidth: '88px !important',
        maxWidth: '88px !important'

      }}
      className="sider"
      collapsed={menuStatus == "pinned" ? false : isClosedPinned == 'pinned' ? true : collapsed}
      // onMouseEnter={() => setCollapsed(menuStatus == "pinned" || isClosedPinned == "pinned" ? null : false)}
      // onMouseLeave={() => setCollapsed(menuStatus == "pinned" || isClosedPinned == 'pinned' ? null : true)}
    >
      <div style={{padding: '16px 8px 8px', display:'flex', flexDirection:'column', gap:'16px', cursor: 'pointer' }}>
        <Row style={{ paddingLeft: 8 }} className='sider-logo'>
          <Col xs={isCollapsed ? '' : 20} style={{height: '40px'}} onClick={() => history.push(landingPage)}>
            {/* <img src={isCollapsed ? logo_icon : logo} style={ isCollapsed ? null : {width: '100%' }}/> */}
            {renderLogo(isCollapsed)}
          </Col>
          {isCollapsed ?
            <Tooltip title="Cilck here to expand the side menu"><img className='collapse-icon' src={sidebar_collapse} onClick={handleToggle} /></Tooltip>
            :
            <Col xs={4} className='alignRight' style={{ marginTop: '2px' }}>
              <Tooltip title="Cilck here to minimize the side menu"><img className='toggleIcon' src={sidebar_expand} onClick={handleToggle} /></Tooltip>
            </Col>
          }
        </Row>
      
      {/* </div> */}
      <MenuOptions 
         history={props.history}
         currentUser={ currentUser }
         menuButtonToggleSidebar={ props.menuButtonToggleSidebar }
         orderNumberSearch={ props.orderNumberSearch }
         filterPlaceHolder={ props.filterPlaceHolder }
         handleFilterValueChange={ props.handleFilterValueChange }
         handleVisibleChange={ props.handleVisibleChange }
         filterWindow={ props.filterWindow }
         handleFilterPlaceHolderChange={ props.handleFilterPlaceHolderChange }
         handleSearch={ props.handleSearch}
         handleSaveNSearch={props.handleSaveNSearch}
         landingPage={ (landingPage) }
         handleOnChange={ props.handleOnChange }
         isSuperAdmin={ props.isSuperAdmin }
         isShipper={ props.isShipper }
         isDriver={props.isDriver}
         WarehouseContext={ props.warehouseContext }
         isCollapsed={isCollapsed}
         orgRules={userContext?.orgRules}
      />
      </div>
      
      <div 
        style={{
          // paddingBottom: isCollapsed ? 0 : 20,
          overflowY: isCollapsed ? "scroll" : "scroll", 
          maxHeight: isCollapsed ? "none" : "calc(100vh - 234px)",
          height: isCollapsed ? "calc(100vh - 270px)" : "calc(100vh - 234px)",
          smsOverflowStyle: "none",  /* IE and Edge */
          scrollbarWidth: "none",
          borderTop: "1px solid #eef2f5"
        }}
        className='side_menu'
      >
        <SideMenu history={props.history} 
        changeMenuStatus={changeMenuStatus} 
        menuStatus={menuStatus} 
        isClosedPinned={isClosedPinned}
        renderBanner={renderBanner} 
        />
      </div>
      <div style={{borderTop: "1px solid #EEF2F5"}}>
        <SiderFooter
          isSuperAdmin={props.isSuperAdmin}
          isShipper={props.isShipper}
          isDriver={props.isDriver}
          currentUser={currentUser}
          isCollapsed={isCollapsed}
        />
      </div>
    </Sider>
  );
}

export default withRouter(MemoizedSider);
